import { render, staticRenderFns } from "./ColorModuleTable.vue?vue&type=template&id=199bcf56&scoped=true"
import script from "./ColorModuleTable.vue?vue&type=script&lang=ts"
export * from "./ColorModuleTable.vue?vue&type=script&lang=ts"
import style0 from "./ColorModuleTable.vue?vue&type=style&index=0&id=199bcf56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199bcf56",
  null
  
)

export default component.exports